// Privacy.js

import React from "react";
import "../styles/Privacy.css";

export default function Privacy() {
  return (
    <section className="privacy-page">
      <div className="privacy-container">

        <h1>Privacy Policy</h1>
        <p><strong>Last updated:</strong> May 2026</p>

        <p>
          At Fegaropetra Restaurant, we respect your privacy and are committed
          to protecting your personal information.
        </p>

        <h2>1. Information We Collect</h2>
        <p>
          When using our website or reservation system, we may collect:
        </p>

        <ul>
          <li>Name</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>Reservation details</li>
          <li>
            Technical information such as browser/device information and
            website analytics data
          </li>
        </ul>

        <h2>2. Why We Collect Your Data</h2>

        <p>We collect personal information to:</p>

        <ul>
          <li>Process and manage reservations</li>
          <li>Communicate regarding bookings or inquiries</li>
          <li>Improve website performance and user experience</li>
          <li>Maintain website security and functionality</li>
        </ul>

        <h2>3. Analytics and Website Usage</h2>

        <p>
          Our website may use analytics services, such as Firebase Analytics,
          to understand website traffic and improve our services.
          These services may collect anonymous or aggregated usage information.
        </p>

        <h2>4. Data Sharing</h2>

        <p>
          We do not sell or rent personal information.
        </p>

        <p>
          Your information may be processed by trusted service providers used
          for:
        </p>

        <ul>
          <li>Website hosting</li>
          <li>Reservation handling</li>
          <li>Analytics services</li>
        </ul>

        <p>
          These providers process data only as necessary to provide their
          services.
        </p>

        <h2>5. Data Retention</h2>

        <p>
          We keep personal information only for as long as necessary to manage
          reservations, provide customer service, and comply with legal
          obligations.
        </p>

        <h2>6. Your Rights</h2>

        <p>Under GDPR, you may have the right to:</p>

        <ul>
          <li>Request access to your data</li>
          <li>Request correction of inaccurate data</li>
          <li>Request deletion of your data</li>
          <li>Object to or restrict processing where applicable</li>
        </ul>

        <p>
          For privacy-related requests, contact us using the information below.
        </p>

        <h2>7. Contact</h2>

        <p>
          Fegaropetra Restaurant
          <br />
          Corfu, Greece
          <br />
          Email: feggaropetraseafood@email.com
          <br />
          Phone: +30 2661 043383
        </p>

        <h2>8. Changes to This Policy</h2>

        <p>
          We may update this Privacy Policy from time to time. Updates will be
          posted on this page.
        </p>

      </div>
    </section>
  );
}